import { useMemo } from 'react';
import { getLocale } from 'umi';
import { useCustomAIPromptList } from '@op/components/GPT/PromptList';
import { getPromptText } from '@op/components/GPT/utils';
import { PromptType } from '@op/components/GPT/types';
import { LocaleType } from '@op/types/common';

export interface IDefaultPromptItem {
  id: string;
  prompt_name: string;
  prompt_detail: string;
  is_default: true;
  name?: { [key in LocaleType]: string };
  rawItem?: PromptType;
}

export default function useCustomDefaultPrompt({
  gameInfo,
}: {
  gameInfo: { entity_name: string };
}) {
  const promptList = useCustomAIPromptList({ gameInfo });

  const { rawList, defaultPromptList } = useMemo(() => {
    const list: PromptType[] = Array.isArray(promptList)
      ? promptList
      : promptList?.gemini || [];

    const lang = getLocale() as LocaleType;

    const apiList: IDefaultPromptItem[] = list.map((item, index) => ({
      id: `default-${item.value || index + 1}`,
      prompt_name: item.name?.[lang] || `Default ${index + 1}`,
      prompt_detail: getPromptText(item),
      is_default: true,
      rawItem: item,
      ...(item.name ? { name: item.name } : {}),
    }));

    return { rawList: list, defaultPromptList: apiList };
  }, [promptList]);

  return {
    promptList: rawList,
    defaultPromptList,
  };
}
